import { render } from "./AuthorCompletePage.vue?vue&type=template&id=ab18f624&scoped=true&ts=true"
import script from "./AuthorCompletePage.vue?vue&type=script&lang=ts"
export * from "./AuthorCompletePage.vue?vue&type=script&lang=ts"

import "./AuthorCompletePage.vue?vue&type=style&index=0&id=ab18f624&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1361425700/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab18f624"]])

export default __exports__